<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="margin: 0px 0px;background:rgba(245, 247, 250, 1);padding: 10px;height: 92px;">
          <el-form-item label="综合查询">
            <el-input placeholder="账号/学号/身份证号/姓名" v-model="ruleForm.a"></el-input>
          </el-form-item>
          <el-form-item label="培训单位">
            <el-input placeholder="培训单位" v-model="ruleForm.b"></el-input>
          </el-form-item>
          <el-form-item label="年级">
            <el-select v-model="ruleForm.c" placeholder="请选择年级">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学位">
            <el-select v-model="ruleForm.d" placeholder="请选择学位">
              <el-option label="学士" value="学士"></el-option>
              <el-option label="硕士" value="硕士"></el-option>
              <el-option label="博士" value="博士"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="记录类型">
            <el-select v-model="ruleForm.e" placeholder="请选择记录类型">
              <el-option label="所有上报" value="所有上报"></el-option>
              <el-option label="危机上报" value="危机上报"></el-option>
              <el-option label="咨询师上报" value="咨询师上报"></el-option>
              <el-option label="热线上报" value="热线上报"></el-option>
              <el-option label="谈话记录" value="谈话记录"></el-option>
              <el-option label="危机台账" value="危机台账"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上报状态">
            <el-select v-model="ruleForm.f" placeholder="请选择上报状态">
              <el-option label="所有状态" value="所有状态"></el-option>
              <el-option label="待审核" value="待审核"></el-option>
              <el-option label="已审核" value="已审核"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
        </el-form>
      </el-header>

      <div style="height:100%;background-color: #fff;">
        <el-table :data="tableData" stripe style="width: 100%;margin-top: 20px;">
          <el-table-column prop="Approver" label="学生学号" width="180"></el-table-column>
          <el-table-column prop="RealName" label="姓名" width="180"></el-table-column>
          <el-table-column prop="ApproverTime" label="培养单位"></el-table-column>
          <el-table-column prop="LeaveReason" label="上报人"></el-table-column>
          <el-table-column prop="UserID" label="上报时间"></el-table-column>
          <el-table-column prop="address" label="上报类型"></el-table-column>
          <el-table-column prop="address" label="危机调整"></el-table-column>
          <el-table-column prop="address" label="上报状态"></el-table-column>
          <el-table-column class="xsii" prop="address" label="操作">
            <span @click="Go_Review_key">审核</span>
            <span @click="Go_Review_key">内容修改</span>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndexs" :page-size="10" layout="total, prev, pager, next" :total="Count"
          v-if="Count > 0"></el-pagination>
      </div>
    </el-container>
  </div>
</template>
<script>



export default {
  data() {
    return {
      gradedata:[],
      Count:0,
      pageIndexs:0,
      ruleForm: {
        a: "",
        b: "",
        c: "",
        d: "",
        e: "",
        f: "",
        g: "",
        h: "",
        pageIndex:1
      },
      form: {
        DeptName:"",RealName:"",Status:"",UserID:"",entity:"管理员",pageIndex:1,pageSize:"10"
      },
      tableData: [],
    }
  },
  methods: {
    gourl(val) {
      let routeData = this.$router.resolve({
        path: '/visitors/ReportShow',
        query: { PaperResultID: a },
      })
      window.open(routeData.href, '_blank');
    },
    load(form) {//列表
      this.$Http_Post('ConsultSubscribe/ShowCounselorLeave', {
        form,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data.Lists
          this.Count = Number(res.Data.Counts);
        }
      });
    },
    handleCurrentChange(val) {//分页点击
      this.ruleForm.pageIndex = val
      this.load(this.form)
    },
    Go_Review_key() {
      let routeData = this.$router.resolve({
        path: '../Crisis/Review_key',
        query: { ID: "111" },
      })
      this.$router.push("/Crisis/Review_key?id=111");
    },

    handle(data, node) {
    },

    resetForm() {
    },

    onSelect() {
    },

    jump(val) {
      this.$router.push({ path: "/Crisis/report", query: { id: val } })
    }
  },

  mounted() {
    this.load(this.form)
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
  }
}

</script>

<style>
.Crisis_upreport button {
  margin-bottom: 20px;
}

.Crisis_upreport .cell span {
  color: rgb(31, 52, 245);
  margin-left: 10px;
  text-align: center;
}
</style>